import { combineReducers } from 'redux';

import prosesshjelp from '@helsenorge/core-framework/prosesshjelp/store';
import { additionalPageContentApi } from '@helsenorge/framework-utils/additional-page-content';
import { tjenesteTeksterApi } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { createLanguageReducer } from '@helsenorge/framework-utils/language';

import { resourcesApi } from '../resources';
import { velgBehandlingsstedApi } from './api/velgBehandlingsstedApi';

const rootReducer = combineReducers({
  // Felles
  language: createLanguageReducer(),
  prosesshjelp,
  [additionalPageContentApi.reducerPath]: additionalPageContentApi.reducer,
  [tjenesteTeksterApi.reducerPath]: tjenesteTeksterApi.reducer,
  [resourcesApi.reducerPath]: resourcesApi.reducer,

  // Spesifikt for Velg behandlingssted
  [velgBehandlingsstedApi.reducerPath]: velgBehandlingsstedApi.reducer,
});

export default rootReducer;
